import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { axiosClient } from '../../../library/Service/axiosClient';

const FutureLeadersFour: React.FC = () => {
    const [alumniName, setAlumniName] = useState('');
    const [primaryColor, setPrimaryColor] = useState('#fff');
    const [secondaryColor, setSecondaryColor] = useState('#fffff');
    const [schoolImage, setSchoolImage] = useState<string>(localStorage.getItem('school-image') || '');
    const [poweredByBase64, setPoweredByBase64] = useState<string>('');
    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setUgLogo(imageUrl);
        }
    };
    const [isJoinedUGCollege, setIsJoinedUGCollege] = useState(true); // Default to checked

    const handleUGCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsJoinedUGCollege(event.target.checked);
    };
    const [isJoinedPGCollege, setIsJoinedPGCollege] = useState(true); // Default to checked

    const handlePGCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsJoinedPGCollege(event.target.checked);
    };
    const [isJoinedCompanyCollege, setIsJoinedComapnyCollege] = useState(true); // Default to checked

    const handleCompanyCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsJoinedComapnyCollege(event.target.checked);
    };
    const jwtToken = localStorage.getItem('user-jwt-token');
    const [ugLogo, setUgLogo] = useState('https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/p1-logo.jpg');
    const divRef = useRef<HTMLDivElement>(null);
    const previewRef = useRef<Window | null>(null);
    const [ugCollegeName, setUgCollegeName] = useState('');
    const [ugCourseName, setUgCourseName] = useState('');
    const [pgCollegeName, setPgCollegeName] = useState('');
    const [pgCourseName, setPgCourseName] = useState('');
    const [pgLogo, setPgLogo] = useState('https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/p1-logo.jpg');

    const handlePgFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setPgLogo(imageUrl);
        }
    };
    useEffect(() => {
        if (!jwtToken) {
            window.location.href = '/404'; // Redirect to 404 page
        }
    }, []);

    const normalizeDataUrl = (dataUrlOrBase64: string) => {
        if (!dataUrlOrBase64) return '';

        if (dataUrlOrBase64.startsWith('data:image')) {
            const parts = dataUrlOrBase64.split(',');
            if (parts.length < 2) return dataUrlOrBase64;

            const base64 = parts.slice(1).join(',').trim();
            if (base64.startsWith('PHN2Zy')) return `data:image/svg+xml;base64,${base64}`;

            return dataUrlOrBase64;
        }
        const base64 = dataUrlOrBase64.trim();
        if (base64.startsWith('PHN2Zy')) return `data:image/svg+xml;base64,${base64}`;

        return `data:image/png;base64,${base64}`;
    };

    function dataURLtoBlob(dataUrl: string): Blob {
        const [metadata, base64] = dataUrl.split(',');
        const byteString = atob(base64);
        const mimeString = metadata.split(':')[1].split(';')[0];

        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uintArray[i] = byteString.charCodeAt(i);
        }

        return new Blob([uintArray], { type: mimeString });
    }
    useEffect(() => {
        const loadPoweredByLogo = async () => {
            try {
                const logoUrl = 'https://www.univariety.xyz/prototype/school_dashboard/images/univariety-white-logo.svg';

                const res = await axiosClient().post(`${process.env.REACT_APP_BROADCAST_SERVER}/pre-signup/get-base64-path`, {
                    image: logoUrl,
                });

                if (res.data?.success && res.data?.result) {
                    setPoweredByBase64(normalizeDataUrl(res.data.result));
                } else {
                    setPoweredByBase64('');
                }
            } catch (error) {
                console.error('Failed to load powered-by logo', error);
                setPoweredByBase64('');
            }
        };

        loadPoweredByLogo();
    }, []);

    const handleShareOnSocialMedia = async () => {
        if (!divRef.current) {
            console.error('Element not found!');
            return;
        }

        const { default: html2canvas } = await import('html2canvas');
        const scaleFactor = 3;

        // Step 1: Render the canvas
        const canvas = await html2canvas(divRef.current, {
            backgroundColor: secondaryColor,
            scale: scaleFactor,
            useCORS: true,
            allowTaint: false,
        });

        // Step 2: Resize to exactly 1080 x 1350
        const width = 1080;
        const height = 1350;

        const scaledCanvas = document.createElement('canvas');
        scaledCanvas.width = width;
        scaledCanvas.height = height;

        const ctx = scaledCanvas.getContext('2d');
        if (ctx) {
            ctx.fillStyle = secondaryColor;
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(canvas, 0, 0, width, height);

            const dataUrl = scaledCanvas.toDataURL('image/png', 1.0);
            const imageBlob = dataURLtoBlob(dataUrl); // Use your existing helper

            const apiUrl = `${process.env.REACT_APP_BROADCAST_SERVER}/upload/get-attached`;
            const formData = new FormData();
            formData.append('pdf_doc', imageBlob, 'spotlight_image.png');

            try {
                const response = await axios.post(apiUrl, formData, {
                    headers: {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                });

                if (response.data.success) {
                    sessionStorage.setItem('spotlight_post_image_url', response.data.link);
                    window.location.href = '/socialmedia/socialpost?social_post=1';
                } else {
                    alert('Error uploading image to S3');
                }
            } catch (error) {
                console.error('Error uploading image:', error);
                alert('Failed to upload image.');
            }
        }
    };

    if (!previewRef.current || previewRef.current.closed) {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const popupWidth = 400; // Set desired width
        const popupHeight = 400; // Set desired height
        const left = (screenWidth - popupWidth) / 2;
        const top = (screenHeight - popupHeight) / 2;
    }
    const handleDownload = async (width: number, height: number, filename: string) => {
        if (!divRef.current) {
            console.error('Element not found!');
            return;
        }

        const images = Array.from(divRef.current.querySelectorAll('img')) as HTMLImageElement[];

        try {
            await Promise.all(
                images.map((img) => {
                    return new Promise((resolve, reject) => {
                        if (img.complete && img.naturalWidth > 0) {
                            resolve(true);
                        } else {
                            img.onload = () => resolve(true);
                            img.onerror = () => reject(false);
                        }
                    });
                })
            );

            const { default: html2canvas } = await import('html2canvas');
            const scaleFactor = 3;

            const canvas = await html2canvas(divRef.current, {
                backgroundColor: secondaryColor,
                scale: scaleFactor,
                useCORS: true,
                allowTaint: false,
            });

            const scaledCanvas = document.createElement('canvas');
            scaledCanvas.width = width;
            scaledCanvas.height = height;

            const ctx = scaledCanvas.getContext('2d');
            if (ctx) {
                ctx.fillStyle = secondaryColor;
                ctx.fillRect(0, 0, width, height);
                ctx.drawImage(canvas, 0, 0, width, height);

                const dataUrl = scaledCanvas.toDataURL('image/png', 1.0);
                const link = document.createElement('a');
                link.href = dataUrl;
                link.download = filename;
                link.click();
            }
        } catch (error) {
            console.error('Error generating image:', error);
        }
    };

    const handlePreview = async (width: number, height: number) => {
        if (!divRef.current) {
            console.error('Element not found!');
            return;
        }

        const { default: html2canvas } = await import('html2canvas');
        const scaleFactor = 3;

        const canvas = await html2canvas(divRef.current, {
            backgroundColor: secondaryColor,
            scale: scaleFactor,
            useCORS: true,
            allowTaint: false,
        });

        const scaledCanvas = document.createElement('canvas');
        scaledCanvas.width = width;
        scaledCanvas.height = height;
        const scaledContext = scaledCanvas.getContext('2d');

        if (scaledContext) {
            scaledContext.fillStyle = secondaryColor;
            scaledContext.fillRect(0, 0, width, height);

            // Fit the original canvas inside the new scaled canvas
            scaledContext.drawImage(canvas, 0, 0, width, height);

            const dataUrl = scaledCanvas.toDataURL('image/png', 1.0);

            if (!previewRef.current || previewRef.current.closed) {
                const screenWidth = window.screen.width;
                const screenHeight = window.screen.height;
                const left = (screenWidth - width) / 2;
                const top = (screenHeight - height) / 2;
                previewRef.current = window.open('', 'Preview', `width=${width},height=${height},top=${top},left=${left}`);
            }

            if (previewRef.current) {
                previewRef.current.document.body.innerHTML = '';
                previewRef.current.document.write(
                    `<html><head><title>Preview</title></head><body style="margin: 0; display: flex; align-items: center; justify-content: center; background: #ffffff;"></body></html>`
                );
                const img = document.createElement('img');
                img.src = dataUrl;
                img.style.width = '100%';
                img.style.height = 'auto';
                previewRef.current.document.body.appendChild(img);
            }
        }
    };

    const [companyName, setCompanyName] = useState('');
    const [experties, setExperties] = useState('');
    const [designation, setDesignation] = useState('');
    const [companyLogo, setCompanyLogo] = useState('https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/p1-logo.jpg');

    const handleCompanyFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setCompanyLogo(imageUrl);
        }
    };
    useEffect(() => {
        const fetchSchoolLogo = async () => {
            try {
                const user = sessionStorage.getItem('user');
                const primaryInstitute = user ? JSON.parse(user).primaryInstitute : 0;

                const response = await axios.post(`${process.env.REACT_APP_BROADCAST_SERVER}/pre-signup/get-institute-name`, {
                    id: primaryInstitute,
                });

                if (response.data?.success && response.data.result?.[0]?.logo) {
                    const logoUrl = response.data.result[0].logo;
                    setSchoolImage(logoUrl);
                } else {
                    console.warn('No school logo returned from the API. Using fallback image.');
                }
            } catch (error) {
                console.error('Error fetching school logo:', error);
            }
        };

        fetchSchoolLogo();
    }, []);
    const [alumniProgramBatch, setAlumniProgramBatch] = useState('');
    const [profilePicture, setProfilePicture] = useState('https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/profile_pic.png');

    const handleProfileFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setProfilePicture(imageUrl);
        }
    };
    return (
        <div className="main flex-1 bg-white">
            <section className="alumni_directory_details">
                <div className="max-1140 mx-auto pt-5">
                    <div className="d-flex justify-content-between align-items-center pb-3">
                        <h3 data-aos="fade-left" data-aos-delay="600" className="font-30 font-600 mb-0 block-title position-relative">
                            Create New Image Template <i className="icon-right-arrow font-16 position-relative me-1"></i>
                            <span>Configure</span>
                        </h3>
                    </div>
                </div>
                <div className="max-1140 pb-5 mx-auto">
                    <div className="row g-4">
                        <div className="col-sm-12">
                            <div className="bg-gray-F2F4F7 border-radius-6 p-3 p-sm-4 px-md-5 text-center font-24 font-500">
                                Leaders of the Future 3 for Instagram
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="row g-2 justify-content-between pb-2">
                                <div className="col-auto font-20 font-500">
                                    Category <span className="font-18 font-400">Success Stories</span>
                                </div>
                                <div className="col-auto font-20 font-500">
                                    Size <span className="font-18 font-400">Instagram Post - 480 x 600 px</span>
                                </div>
                            </div>
                            <div className="bg-gray-F2F4F7 border-radius-6 p-3 p-sm-4">
                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <div className="w-100 h-100">
                                            <div className="bg-white border-radius-6 p-4 w-100 border h-100 d-flex justify-content-center ">
                                                <div className="mx-auto overflow-auto">
                                                    <div
                                                        className="leaders-poster-templete-5 position-relative overflow-hidden ratio-484"
                                                        ref={divRef}
                                                        style={{ backgroundColor: primaryColor }}>
                                                        <div className="college-logo">
                                                            <img
                                                                src={
                                                                    schoolImage ||
                                                                    'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/neps-logo.png'
                                                                }
                                                                className="img-fluid"
                                                                alt="College Logo"
                                                            />
                                                        </div>
                                                        <img
                                                            src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/new-template-frame-3.png"
                                                            className="img-fluid"
                                                            alt="Template Frame"
                                                        />
                                                        <div
                                                            className="leaders-poster-title position-absolute"
                                                            style={{ backgroundColor: '#00D0D4' }}>
                                                            <div>Leaders of the Future</div>
                                                        </div>
                                                        <div
                                                            className="leaders-poster-alumni-detail"
                                                            style={{ backgroundColor: '#015255' }}>
                                                            <div className="leaders-poster-alumni-name">{alumniName || 'Sumit'}</div>
                                                            <div className="leaders-poster-alumni-batch-school">
                                                                {' '}
                                                                {alumniProgramBatch || 'Batch 2014'}
                                                            </div>
                                                        </div>
                                                        <div className="leaders-poster-templete-5-alumni">
                                                            <img src={profilePicture} className="w-100" alt="Alumni" />
                                                        </div>
                                                        <div className="listed-points w-100">
                                                            <ul>
                                                                {isJoinedUGCollege && (
                                                                    <li id="divforUG" style={{ borderLeft: '3px solid #015255' }}>
                                                                        <div className="college">
                                                                            <div className="college-course">{ugCourseName || 'BBA'}</div>
                                                                            <div className="college-name">
                                                                                {ugCollegeName || 'MIT School of Management'}
                                                                            </div>
                                                                        </div>
                                                                        <div className="college-name-logo">
                                                                            <img
                                                                                id="uglogo"
                                                                                src={ugLogo}
                                                                                className="img-fluid"
                                                                                alt="UG Logo Preview"
                                                                            />
                                                                        </div>
                                                                    </li>
                                                                )}

                                                                {isJoinedPGCollege && (
                                                                    <li id="divforPG" style={{ borderLeft: '3px solid #015255' }}>
                                                                        <div className="college">
                                                                            <div className="college-course">{pgCourseName || 'MBA'}</div>
                                                                            <div className="college-name">
                                                                                {pgCollegeName || 'Harvard Business School'}
                                                                            </div>
                                                                        </div>
                                                                        <div className="college-name-logo">
                                                                            <img
                                                                                id="pglogo"
                                                                                src={pgLogo}
                                                                                className="img-fluid"
                                                                                alt="PG Logo Preview"
                                                                            />
                                                                        </div>
                                                                    </li>
                                                                )}

                                                                {isJoinedCompanyCollege && (
                                                                    <li id="divforComapany" style={{ borderLeft: '3px solid #015255' }}>
                                                                        <div className="college">
                                                                            <div className="college-course">
                                                                                {designation || 'Software Engineer'}
                                                                            </div>
                                                                            <div className="college-name">{companyName || 'Google'}</div>
                                                                        </div>
                                                                        <div className="college-name-logo">
                                                                            <img
                                                                                id="companylogo"
                                                                                src={companyLogo}
                                                                                className="img-fluid"
                                                                                alt="Company Logo Preview"
                                                                            />
                                                                        </div>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                        <div
                                                            className="footer-text position-absolute w-100 bottom-0"
                                                            style={{ backgroundColor: '#38A5AA', color: '#fff' }}>
                                                            <div className="left-text">
                                                                <h6 className="d-block font-600 mb-0">Expertise</h6>
                                                                <p> {experties || 'Strategic Planning & Market Research'}</p>
                                                            </div>
                                                            <hr />
                                                            <div className="powerby w-100">
                                                                <span className="text-white">Powered By </span>
                                                                <img
                                                                    src={
                                                                        poweredByBase64 ||
                                                                        'https://www.univariety.xyz/prototype/school_dashboard/images/univariety-white-logo.svg'
                                                                    }
                                                                    alt="Powered by Univariety"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="bg-white border-radius-6 p-4 h-100">
                                            <div className="h-100 pt-3">
                                                <form className="row g-3">
                                                    <div className="col-md-12">
                                                        <div className="row g-3 align-items-center">
                                                            <div className="col-12">
                                                                <label className="form-label m-0 mb-0 font-16 font-600">
                                                                    ADD ALUMNI PROFILE
                                                                </label>
                                                            </div>
                                                            <div className="col-auto col-md-auto col-lg-6"></div>
                                                            <div className="col-12">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Alumni Name"
                                                                    value={alumniName}
                                                                    onChange={(e) => setAlumniName(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-12">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Alumni Program and Batch Year"
                                                                    value={alumniProgramBatch}
                                                                    onChange={(e) => setAlumniProgramBatch(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="upload_section">
                                                        <input
                                                            type="file"
                                                            id="cloud-computing"
                                                            accept="image/*"
                                                            onChange={handleProfileFileUpload}
                                                        />
                                                        <div className="row g-2 align-items-center justify-content-center">
                                                            <div className="col-sm d-flex align-items-center justify-content-center">
                                                                <div className="cloud-wrap px-3">
                                                                    <div className="cloud-img">
                                                                        <img
                                                                            src="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/cloud-computing.svg"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="cloud-text d-flex align-items-center">
                                                                        Upload Profile Picture{' '}
                                                                        <a href="#" className="btn-darkblue text-decoration-none ms-2">
                                                                            Upload
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="row g-3 align-items-center">
                                                            <div className="col-sm-5 col-auto">
                                                                <div className="d-flex flex-wrap justify-content-center justify-content-sm-start align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="DataSet"
                                                                        id="JoinedUGCollege"
                                                                        value="Joined UG College"
                                                                        className="form-check-input ratio20 m-0"
                                                                        checked={isJoinedUGCollege}
                                                                        onChange={handleUGCheckboxChange}
                                                                    />
                                                                    <label
                                                                        htmlFor="JoinedUGCourse"
                                                                        className="form-check-label font-16 font-500 ms-2">
                                                                        Joined UG College
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-7 col">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter UG College Name"
                                                                    id="ugcollegename"
                                                                    value={ugCollegeName}
                                                                    onChange={(e) => setUgCollegeName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="row g-3 align-items-center">
                                                            <div className="col-sm-5 col-auto">
                                                                <div className="d-flex flex-wrap justify-content-center justify-content-sm-start align-items-center">
                                                                    <label
                                                                        htmlFor="JoinedUGCourse"
                                                                        className="form-check-label font-16 font-500 ms-2">
                                                                        Joined UG Course
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-7 col">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter PG Course Name"
                                                                    id="ugcoursename"
                                                                    value={ugCourseName}
                                                                    onChange={(e) => setUgCourseName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="upload_section">
                                                        <input type="file" id="uploadug" accept="image/*" onChange={handleFileUpload} />
                                                        <div className="row g-2 align-items-center justify-content-center">
                                                            <div className="col-sm d-flex align-items-center justify-content-center">
                                                                <div className="cloud-wrap px-3">
                                                                    <div className="cloud-img">
                                                                        <img
                                                                            src="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/cloud-computing.svg"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="cloud-text d-flex align-items-center">
                                                                        Upload UG Institute Logo{' '}
                                                                        <a href="#" className="btn-darkblue text-decoration-none ms-2">
                                                                            Upload
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="row g-3 align-items-center">
                                                            <div className="col-sm-5 col-auto">
                                                                <div className="d-flex flex-wrap justify-content-center justify-content-sm-start align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="DataSet"
                                                                        id="JoinedUGCollege"
                                                                        value="Joined UG College"
                                                                        className="form-check-input ratio20 m-0"
                                                                        checked={isJoinedPGCollege}
                                                                        onChange={handlePGCheckboxChange}
                                                                    />
                                                                    <label
                                                                        htmlFor="pgcollegename"
                                                                        className="form-check-label font-16 font-500 ms-2">
                                                                        Joined PG College
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-7 col">
                                                                <input
                                                                    id="pgcollegename"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter College Name"
                                                                    value={pgCollegeName}
                                                                    onChange={(e) => setPgCollegeName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* PG Course Name Input */}
                                                    <div className="col-12">
                                                        <div className="row g-3 align-items-center">
                                                            <div className="col-sm-5 col-auto">
                                                                <div className="d-flex flex-wrap justify-content-center justify-content-sm-start align-items-center">
                                                                    <label
                                                                        htmlFor="pgcoursename"
                                                                        className="form-check-label font-16 font-500 ms-2">
                                                                        Joined PG Course
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-7 col">
                                                                <input
                                                                    id="pgcoursename"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Course Name"
                                                                    value={pgCourseName}
                                                                    onChange={(e) => setPgCourseName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* PG Logo Upload */}
                                                    {/* PG Logo Upload */}

                                                    <div className="upload_section">
                                                        <input type="file" id="uploadpg" accept="image/*" onChange={handlePgFileUpload} />
                                                        <div className="row g-2 align-items-center justify-content-center">
                                                            <div className="col-sm d-flex align-items-center justify-content-center">
                                                                <div className="cloud-wrap px-3">
                                                                    <div className="cloud-img">
                                                                        <img
                                                                            src="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/cloud-computing.svg"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="cloud-text d-flex align-items-center">
                                                                        Upload PG Institute Logo{' '}
                                                                        <a href="#" className="btn-darkblue text-decoration-none ms-2">
                                                                            Upload
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="row g-3 align-items-center">
                                                            <div className="col-sm-5 col-auto">
                                                                <div className="d-flex flex-wrap justify-content-center justify-content-sm-start align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="DataSet"
                                                                        id="JoinedUGCollege"
                                                                        value="Joined UG College"
                                                                        className="form-check-input ratio20 m-0"
                                                                        checked={isJoinedCompanyCollege}
                                                                        onChange={handleCompanyCheckboxChange}
                                                                    />
                                                                    <label
                                                                        htmlFor="companyname"
                                                                        className="form-check-label font-16 font-500 ms-2">
                                                                        Company Name
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-7 col">
                                                                <input
                                                                    id="companyname"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Company Name"
                                                                    value={companyName}
                                                                    onChange={(e) => setCompanyName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Designation Input */}
                                                    <div className="col-12">
                                                        <div className="row g-3 align-items-center">
                                                            <div className="col-sm-5 col-auto">
                                                                <div className="d-flex flex-wrap justify-content-center justify-content-sm-start align-items-center">
                                                                    <label
                                                                        htmlFor="designation"
                                                                        className="form-check-label font-16 font-500 ms-2">
                                                                        Designation
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-7 col">
                                                                <input
                                                                    id="designation"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Designation Name"
                                                                    value={designation}
                                                                    onChange={(e) => setDesignation(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Company Logo Upload */}

                                                    <div className="upload_section">
                                                        <input
                                                            type="file"
                                                            id="uploadcompany"
                                                            accept="image/*"
                                                            onChange={handleCompanyFileUpload}
                                                        />
                                                        <div className="row g-2 align-items-center justify-content-center">
                                                            <div className="col-sm d-flex align-items-center justify-content-center">
                                                                <div className="cloud-wrap px-3">
                                                                    <div className="cloud-img">
                                                                        <img
                                                                            src="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/cloud-computing.svg"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="cloud-text d-flex align-items-center">
                                                                        Upload Company Logo{' '}
                                                                        <a href="#" className="btn-darkblue text-decoration-none ms-2">
                                                                            Upload
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="row g-3 align-items-center">
                                                            <div className="col-sm-5 col-auto">
                                                                <div className="d-flex flex-wrap justify-content-center justify-content-sm-start align-items-center">
                                                                    <label
                                                                        htmlFor="ExpertiseText"
                                                                        className="form-check-label font-16 font-500 ms-2">
                                                                        Expertise Text
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-7 col">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Expertise Details"
                                                                    value={experties}
                                                                    onChange={(e) => setExperties(e.target.value)}
                                                                    maxLength={65}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label m-0 mb-1 font-16 font-500">Primary Color Shade</label>
                                                        <div className="color-field">
                                                            <label>
                                                                <img
                                                                    src="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/color-fill.svg"
                                                                    alt=""
                                                                />
                                                            </label>
                                                            <input
                                                                type="color"
                                                                className="flex-1"
                                                                value={primaryColor}
                                                                onChange={(e) => setPrimaryColor(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label m-0 mb-1 font-16 font-500">
                                                            Secondary Color Shade
                                                        </label>
                                                        <div className="color-field">
                                                            <label>
                                                                <img
                                                                    src="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/color-fill.svg"
                                                                    alt=""
                                                                />
                                                            </label>
                                                            <input
                                                                type="color"
                                                                className="flex-1"
                                                                value={secondaryColor}
                                                                onChange={(e) => setSecondaryColor(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-12">
                            <div className="action_btns max-100per mt-0">
                                <button type="button" className="nextbtn my-2 my-sm-0 mx-2 px-5" onClick={() => handlePreview(480, 600)}>
                                    <span className="">Preview</span>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-green my-2 my-sm-0 mx-2 height-45 px-5"
                                    onClick={() => handleDownload(480, 600, 'save_as_insta.jpg')}>
                                    <span className="px-3">Save as Image</span>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-border-gray my-2 my-sm-0 mx-3 height-45"
                                    onClick={handleShareOnSocialMedia}>
                                    <span className="px-3">Share on Social Media</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FutureLeadersFour;
